import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { SKELETON_ANIMATION, skeletonTintSx } from './skeletonTokens';

export interface ChartAreaSkeletonProps {
  titleWidth?: string | number;
  height?: number;
}

/**
 * Card-style chart placeholder (title + large rectangular plot area).
 */
export const ChartAreaSkeleton: React.FC<ChartAreaSkeletonProps> = ({
  titleWidth = '40%',
  height = 260,
}) => (
  <Box sx={{ p: 0 }} role="status" aria-label="Loading chart">
    <Skeleton
      variant="text"
      animation={SKELETON_ANIMATION}
      width={titleWidth}
      height={28}
      sx={{ mb: 2, ...skeletonTintSx }}
    />
    <Skeleton
      variant="rounded"
      animation={SKELETON_ANIMATION}
      height={height}
      sx={{ borderRadius: 2, ...skeletonTintSx }}
    />
  </Box>
);
